import { redirect } from "react-router-dom";
import { authService } from "@/services/auth/authService.ts";
import { AuthError } from "@/types/errorTypes/authError";

export const registerAction = async ({ request }: { request: Request }) => {
  const data = await request.json();
  try {
    const isRegisterSuccess = await authService.register(data);
    if (isRegisterSuccess) {
      return redirect("/login");
    }
    return true;
  } catch (err) {
    const error = err as AuthError;
    // You can handle different error cases here
    const errorMessage = error.message || "Invalid credentials";
    return false;
  }
};
